import { Divider } from "@material-ui/core";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Tab from "@mui/material/Tab";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAttributes, GetUserId, GetUserInfo } from "../../../_utilities/getUserInfo";
// pages
import { Box, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import * as _ser from "../../../_redux/_services/ApplicantsSlice";
import * as _props from "../../../_redux/_services/JobPostingSlice";
import { customFieldsAsync } from "../../../_redux/_services/UserManagerSlice";
import RightSideBar from "../../../components/Rightsidebar/RightSideBar";
import SendSms from "../../../components/SendSms/SendSms";
import { AddProjectFooterIllustration } from "../../../Icons/AddProjectFooterIllustration";
import { SendSMSillu } from "../../../Icons/SendSMSillu";
import AddToProject from "../../Projects/AddApplicantsToProject/AddApplicantsToProject";
import AddApplicantAssociatedJobs from "../../Applicants/ApplicantsAssociatedJobs/AddApplicantAssociatedJobs";

import "../../Applicants/ApplicantsTable/ApplicantsTable.css";
import DuplicateApplicantsManualUploadPopup from "../../Applicants/ApplicantsTable/DuplicateApplicantsManualUploadPopup";
import ApplicantsManualUploadPopup from "../../Applicants/ApplicantsTable/ApplicantsManualUploadPopup";
import { ApplicantsReadExcelData } from "../../Applicants/ApplicantsTable/ApplicantsReadExcelData";
import { ApplicantsRenderData } from "../../Applicants/ApplicantsTable/ApplicantsRenderData";
import { setSelectedApplicant } from "../../../_redux/SelectedApplicantSlice";
import Cookies from "js-cookie";

const initalState = { data: null, message: "", isloader: true };

const getApplicantPath = () =>
  Cookies.get("applicantViewPreference") || "/ats/layout/applicants/landing";

const ApplicantsCreateFlow = ({
  selectedApplicantsIds,
  componetType,
  setComponentType,
  setSearchFilter
}) => {
  const [users, setUsers] = useState([]);
  const [config, setConfig] = useState(configuration);
  const [isRightSidePannel, setIsRightSidePannel] = useState(false);
  const [isBulkuploadResponse, setIsBulkuploadResponse] = useState(false);
  const [bulkUploadMessage, setBulkUploadMessage] = useState({});

  const [isDisableBtn, setIsDisableBtn] = useState(true);
  const [manualApplicatsConfirmPopup, setManualApplicatsConfirmPopup] =
    useState(false);
  const [updateProfileWithNewResume, setUpdateProfileWithNewResume] =
    useState(null);
  const [duplicateApplicatsConfirmPopup, setDuplicateApplicatsConfirmPopup] =
    useState(false);
  const [
    twoDuplicateApplicatsConfirmPopup,
    setTwoDuplicateApplicatsConfirmPopup,
  ] = useState(false);
  const [skipId, setSkipId] = useState(null);
  const [skipName, setSkipName] = useState(null);
  const [footerImg, setFooterImg] = useState(false);
  const [smsCandidates, setSmsCandidates] = useState([]);
  const [selectedApplicants, setSelectedApplicants] = useState([]);
  const [pannelobj, setPannelobj] = useState({
    title: "",
    description: "",
    bgImage: "",
    navigateTo: "",
  });
  const [uploadedDocuments, setUploadedDocuments] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedJob, setSelectedJob] = useState({ jobId: 0, jobCode: "" });

  const [isAssociateJob, setIsAssociateJob] = useState(false);
  const [isAssociate, setIsAssociate] = useState(null);

  const [sourceId, setSourceId] = useState(0);
  const [defaultFile, setDefaultFile] = useState(null);
  const [isBulk, setIsBulk] = useState(false);
  const [showLandingPage, setShowLandingPage] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    setSelectedApplicants(selectedApplicantsIds);
    setSmsCandidates(selectedApplicantsIds);
  }, [selectedApplicantsIds]);


  const applicantsData = useSelector((state) => state.GetListApplicants.data);
  const bulkUploadResumeData = useSelector(
    (store) => store.BulkUploadResume.data,
  );

  useEffect(() => {
    if (bulkUploadResumeData) {
      setIsBulkuploadResponse(true);
      setBulkUploadMessage(bulkUploadResumeData);
      dispatch(_ser.bulkUploadResumeStartReducer(initalState));
    }
  }, [bulkUploadResumeData]);

  const FetchData = async (obj) => {
    setUsers([]);
    let configure = JSON.parse(JSON.stringify(config));
    configure.currentPage = obj.current;
    configure.totalRecordsCount = 0;
    setConfig(configure);
    dispatch(_ser.getListApplicantsAsync(config.limitData, obj.offset));
  };

  useEffect(() => {
    if (applicantsData !== null) {
      const myData = JSON.parse(JSON.stringify(applicantsData));
      setUsers([]);
      if (myData?.rows?.length > 0) {
        myData.rows.forEach((e) => {
          e["isChecked"] = false;
          e.userFirstName = e.userFirstName ? e.userFirstName : " ";
          e.userLastName = e.userLastName ? e.userLastName : " ";
          e["createdBy"] = e.userFirstName + " " + e.userLastName;
          e["ApplicantName"] = e.firstName + " " + e.lastName;
        });
        let configure = JSON.parse(JSON.stringify(config));
        configure.totalRecords = myData.total_count / config.limitData;
        configure.totalRecordsCount = myData?.total_count;
        setConfig(configure);
        setUsers(myData.rows);
        dispatch(_ser.getListApplicantsStartReducer(initalState));
      }
    }
  }, [applicantsData]);

  const { data: UploadDocCode, docId: UploadDocId } = useSelector((state) => state.UploadDocuments);

  const selectedJobDetails = useSelector(
    (state) => state.SetSelectedJobDetails.data,
  );

  const onReceivePropsHandler = (pannel, load, bool) => {
    setIsBulkuploadResponse(load !== "getFetch" ? pannel : false);
    setIsAssociateJob(pannel);
    setShowLandingPage(false);
    if (load === "close") {
      setUploadedDocuments([]);
      setIsAssociate(null);
      setComponentType("");
      setSelectedApplicants([]);
    }
    if (load === "Back") {
      setIsRightSidePannel(true);
      setUploadedDocuments(uploadedDocuments);
      setComponentType("newApplicants");
    }
    if (load?.type === "AssociateJob") {
      setComponentType("AssociateJob");
      setIsAssociateJob(true);
      setIsAssociate(false);
      setUploadedDocuments(load?.data || []);
      setIsBulk(load?.isBulk);
    } else if (load === "linkNewApplicantToJob") {
      setIsRightSidePannel(true);
    } else if (load?.type === "associateJobSave") {
      setComponentType("associateJobSave");
      setIsAssociate(true);
      setShowLandingPage(true);
    } else if (pannel === false && load !== "Back") {
      setComponentType("");
    }
    let obj1 = { current: 1, offset: 1 };
    FetchData(obj1);
    setSearchFilter('');
    if (!pannel) {
      setSmsCandidates([]);
    }
  };

  useEffect(() => {
    if (
      selectedJobDetails &&
      selectedJobDetails.length > 0 &&
      Object.keys(uploadedDocuments).length > 0
    ) {
      setSelectedJob({
        jobId: selectedJobDetails[0].id,
        jobCode: selectedJobDetails[0].jobCode,
      });
      setIsLoading(true);
      let formData = new FormData();
      const { imgData, userInfo, sourced, GetUserId } = uploadedDocuments;
      for (let i = 0; i < imgData?.length; i++) {
        formData.append("Resume", imgData[i]);
      }
      formData.append("customerId", GetUserId);
      formData.append("userId", userInfo?.userId);
      if (imgData?.length === 1) {
        dispatch(_ser.uploadResumeAsync(formData, true));
      } else {
        formData.append("userFirstName", userInfo.firstName);
        formData.append("userLastName", userInfo.lastName);
        formData.append("email", userInfo.email);
        formData.append("resumesourceId", sourced.id ? sourced.id : "");
        formData.append("resumesource", sourced.name ? sourced.name : "");
        formData.append("submittedBy", userInfo?.id);
        formData.append("DbUserId", userInfo?.id);
        formData.append("source", "ATS");
        dispatch(
          _ser.bulkUploadResumeAsync(formData, true, {
            jobId: selectedJobDetails[0].id,
            jobCode: selectedJobDetails[0].jobCode,
          }),
        );
      }
    }
  }, [selectedJobDetails]);

  const bulkUploadResumeCode = useSelector(
    (store) => store.BulkUploadResume.code,
  );
  const uploadResumeData = useSelector((store) => store.UploadResume.data);
  const duplicateResume = useSelector((store) => store.UploadResume.code);
  const updateResumeData = useSelector((store) => store.UploadResume);
  const isDuplicats = useSelector((store) => store.UploadResume.isDuplicats);

  useEffect(() => {
    if (bulkUploadResumeCode === 200 && isAssociate === false) {
      setIsLoading(false);
      dispatch(_ser.bulkUploadResumeStartReducer(initalState));
    } else {
      setIsLoading(false);
    }
  }, [bulkUploadResumeCode]);

  useEffect(() => {
    if (
      uploadResumeData !== null &&
      uploadedDocuments?.sourced !== "" &&
      uploadedDocuments?.imgData?.length !== 0 &&
      isAssociate !== null
    ) {
      setIsLoading(false);
      let json = JSON.parse(JSON.stringify(uploadResumeData[0]));
      navigate("/ats/layout/applicants/create-new", {
        state: {
          applicant: json,
          sourceId: uploadedDocuments?.sourced,
          uploadfile: uploadedDocuments?.imgData[0],
          isAssociate: selectedJob,
          isduplicate: false,
          showLandingPage: showLandingPage,
        },
      }); //props.isduplicate
      dispatch(_ser.uploadResumeStartReducer(initalState));
    }
  }, [uploadResumeData]);

  useEffect(() => {
    if (
      duplicateResume === 500 &&
      updateResumeData.updatedata !== null &&
      isAssociate !== null
    ) {
      setIsLoading(false);
      dispatch(_ser.uploadResumeStartReducer(initalState));
      let obj = {
        data: updateResumeData.updatedata[0],
        message: updateResumeData.message,
        id: updateResumeData.id,
        oldApplicantName: updateResumeData.oldApplicantName,
      };
      onManualPopup(
        false,
        uploadedDocuments?.sourced,
        uploadedDocuments?.imgData ? uploadedDocuments?.imgData[0] : null,
        obj,
      );
    }
    if (duplicateResume === 500 && isAssociate === false) {
      setIsLoading(false);
      dispatch(_ser.uploadResumeStartReducer(initalState));
    } else if (duplicateResume === 400 && isAssociate !== null) {
      setIsLoading(false);
      dispatch(_ser.uploadResumeStartReducer(initalState));
      onManualPopup(
        true,
        uploadedDocuments?.sourced,
        uploadedDocuments?.imgData[0],
        null,
      );
    }
    if (isDuplicats !== null && isAssociate !== null) {
      setIsLoading(false);
      onManualPopup(false, null, null, { data: isDuplicats });
    }
  }, [duplicateResume, updateResumeData, isDuplicats]);

  const onManualuploadHandler = () => {
    let json = {
      Applicants: {
        firstName: "",
        lastName: "",
        phone: "",
        emailId: "",
        alternateContactNumber: "",
        resumesourceId: sourceId,
      },
      totalExperience: null,
      linkedIn: "",
      educationDetails: [],
      workExp: [],
      skillDetails: [],
      certification: [],
      identifier: "",
      customFields: JSON.stringify([]),
      jobDescription: "",
      source: sourceId,
      id: 0,
    };
    navigate("/ats/layout/applicants/create-new", {
      state: {
        applicant: json,
        sourceId: sourceId,
        uploadfile: defaultFile,
        isAssociate: isAssociate !== null ? selectedJob : null,
        isduplicate: false,
        isManual: true,
      },
    });
  };

  const onManualPopup = (isPopup, sourceId, file, obj) => {
    if (sourceId !== null && file !== null) {
      setManualApplicatsConfirmPopup(isPopup);
      setSourceId(sourceId);
      setDefaultFile(file);
      if (obj !== null) {
        setSkipId(obj.id);
        let json = {
          Applicants: obj.data.Applicants,
          totalExperience: obj.data.totalExperience
            ? obj.data.totalExperience
            : null,
          linkedIn: obj.data.linkedIn ? obj.data.linkedIn : "",
          educationDetails: obj.data.educationDetails
            ? obj.data.educationDetails
            : [],
          workExp: obj.data.workExperiences ? obj.data.workExperiences : [],
          skillDetails: obj.data.skillDetails ? obj.data.skillDetails : [],
          certification: obj.data.certifications ? obj.data.certifications : [],
          identifier: obj.data.identifier ? obj.data.identifier : "",
          jobDescription: "",
          customFields: JSON.stringify([]),
          source: sourceId,
          id: obj.id,
          oldApplicantName: obj.oldApplicantName ? obj.oldApplicantName : "",
          Resume: file,
          locationData: obj.data.locationData ? obj.data.locationData : [],
        };
        setUpdateProfileWithNewResume(json);
        setDuplicateApplicatsConfirmPopup(true);
        setSourceId(sourceId);
      }
    } else {
      setTwoDuplicateApplicatsConfirmPopup(true);
      setSkipId(obj.data.id);
      setSkipName(obj.data.name);
    }
  };

  useEffect(() => {
    const associatedToJobs = async () => {
      if (UploadDocCode === 200 && skipId && UploadDocId && selectedJobDetails) {
        let userInfo = await GetUserInfo();
        let userId = await getAttributes();
        let data = {
          id: skipId,
          jobCode: selectedJobDetails[0].jobCode,
          docId: UploadDocId,
          firstName: userId[0].firstName,
          lastName: userId[0].lastName,
          portalassociatedJobs: "associatedJobs",
          status: "Associated",
          source: "ATS",
          submittedBy: userInfo[0].userId,
          userId: userId[0].userId,
        };
        let jobs = [];
        if (selectedJobDetails && selectedJobDetails.length > 0) {
          selectedJobDetails.forEach((job) => {
            let obj = {};
            obj["jobId"] = job.id;
            obj["jobCode"] = job.jobCode;
            jobs.push(obj);
          });
        }
        data["jobs"] = jobs.length > 0 ? jobs : [];
        dispatch(_ser.addAssociatedjobsAsync(skipId, data, "posting"));
      }
      else if (UploadDocCode === 200 && skipId) {
        if (getApplicantPath().includes("applicants/list")) {
          dispatch(setSelectedApplicant({ applicantDetails: { id: skipId } }));
          navigate(`/ats/layout/applicants/list/landing?tab=document`, {
            state: { selectedApplicant: { id: skipId }, isDocument: true },
          });
        } else {
          navigate(`/ats/layout/applicants/documents/${skipId}`);
        }
      }
    }
    associatedToJobs();
  }, [UploadDocCode, skipId, UploadDocId, selectedJobDetails]);

  const AddAssociatedjobscode = useSelector((state) => state.AddAssociatedjobs.data);

  useEffect(() => {
    if (AddAssociatedjobscode === 200 && skipId) {
      dispatch(_ser.addAssociatedjobsStartReducer(initalState));
      dispatch(setSelectedApplicant({ applicantDetails: { id: skipId } }));
      navigate(`/ats/layout/applicants/list/landing?tab=document`, {
        state: { selectedApplicant: { id: skipId }, isDocument: true },
      });
    }
  }, [AddAssociatedjobscode, skipId]);

  return (
    <>
      {componetType === "newApplicants" ? (
        <div className="applicantUploadpannel">
          <RightSideBar
            componentData={
              <ApplicantsRenderData
                onReceivechildProps={onReceivePropsHandler}
                isAssociate={null}
                onManualPopup={onManualPopup}
                input={uploadedDocuments}
                showCreateNew={true}
              />
            }
            componentLayout={!footerImg ? pannelobj1 : pannelobj2}
            isFooter={false}
            footerImg={<SendSMSillu />}
            onReceiveProps={onReceivePropsHandler}
          />
        </div>
      ) : componetType === "uploadExcel" ? (
        <RightSideBar
          componentData={
            <ApplicantsReadExcelData
              onReceivechildProps={onReceivePropsHandler}
            />
          }
          componentLayout={!footerImg ? pannelobj1 : pannelobj2}
          footerImg={<SendSMSillu />}
          onReceiveProps={onReceivePropsHandler}
        />
      ) : isBulkuploadResponse ? (
        <div id="bulkUploadResults">
          <RightSideBar
            componentData={
              <ComponentRenderData
                data={bulkUploadMessage}
                onReceivechildProps={onReceivePropsHandler}
              />
            }
            componentLayout={bulkResponseObj}
            onReceiveProps={onReceivePropsHandler}
          />
        </div>
      ) : componetType === "sendSMS" ? (
        <div id="sendSMS">
          <RightSideBar
            componentData={
              <SendSms
                data={smsCandidates}
                onReceivechildProps={onReceivePropsHandler}
              />
            }
            componentLayout={smsObj}
            onReceiveProps={onReceivePropsHandler}
          />
        </div>
      ) : componetType === "addToProject" ? (
        <div id="addToProject" className="rightsidebarbtn">
          <RightSideBar
            componentData={
              <AddToProject
                applicantIds={selectedApplicants}
                onReceivechildProps={onReceivePropsHandler}
              />
            }
            componentLayout={addToProjectObj}
            footerImg={<AddProjectFooterIllustration />}
            onReceiveProps={onReceivePropsHandler}
          />
        </div>
      ) : isAssociateJob ? (
        <AddApplicantAssociatedJobs
          componentType={"AssociatedJobs"}
          isRightSidePannel={isAssociateJob}
          AccociatedJobSeekerList={[]}
          onPropsReceive={onReceivePropsHandler}
          questionsData={[]}
          getData={null} //getData
          pannelobj={pannelobj}
          isAssociate={isAssociate}
          isBulk={isBulk}
        />
      ) : (
        ""
      )}
      {/* Manual Upload popup */}
      {manualApplicatsConfirmPopup === true && (
        <section className="customModal">
          <div className="customModalDiv">
            <h1 className="modal-header">Error</h1>
            <div className="modal-body">
              <p>
                We are currently facing a technical glitch. Please select to
                upload resume manually.
              </p>
              <div className="modalActionBtns">
                <Button
                  type="button"
                  className="cancelBtn"
                  style={{ marginRight: "20px" }}
                  onClick={() => {
                    setManualApplicatsConfirmPopup(false);
                    setUploadedDocuments([]);
                  }}
                >
                  Cancel
                </Button>
              </div>
              <Button
                type="button"
                variant="contained"
                className="saveBtn"
                sx={{ width: "143px !important" }}
                onClick={onManualuploadHandler}
              >
                Upload Manually
              </Button>
            </div>
          </div>
        </section>
      )}

      {duplicateApplicatsConfirmPopup === true && (
        <ApplicantsManualUploadPopup
          skipId={skipId}
          isAssociatedApplicant={isAssociate ? isAssociate : false}
          updateProfileWithNewResume={updateProfileWithNewResume}
          sourceId={sourceId}
          defaultFile={defaultFile}
          setDuplicateApplicatsConfirmPopup={() => {
            dispatch(_ser.uploadResumeStartReducer(initalState));
            setUploadedDocuments([]);
            setUpdateProfileWithNewResume(null);
            setIsAssociate(null);
            setDuplicateApplicatsConfirmPopup(false);
            // setSkipId(null);
          }}
        />
      )}

      {twoDuplicateApplicatsConfirmPopup === true && (
        <DuplicateApplicantsManualUploadPopup
          skipId={skipId}
          skipName={skipName}
          setTwoDuplicateApplicatsConfirmPopup={() => {
            setTwoDuplicateApplicatsConfirmPopup(false);
            dispatch(_ser.uploadResumeStartReducer(initalState));
            setSkipId(null);
            setSkipName(null);
            setUploadedDocuments([]);
          }}
        />
      )}
    </>
  );
};

const ComponentRenderData = ({ data, onReceivechildProps }) => {
  return (
    <>
      <div className="tabs">
        <TabContext value={"1"}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList
              onChange={""}
              aria-label="lab API tabs example"
              className="UpdateStatustabsvalue"
            >
              <Tab label="Bulk upload Results" value="1" />
            </TabList>
          </Box>
          <TabPanel value="1">
            {data && (
              <div>
                <div className="jobsdatacss">
                  <tr>
                    <td>Total Resumes</td>
                    <td>:</td>
                    <td>{data.totalResume}</td>
                  </tr>
                </div>
                <br />
                <Divider className="secline" />
                <p>
                  Your documents have been submitted for offline processing.
                  Once the process is complete, you will receive a confirmation
                  email and Please refresh the page.
                </p>
                {data?.data?.map((msg) => {
                  return (
                    <ul>
                      <li
                        style={{ textAlign: "left" }}
                        dangerouslySetInnerHTML={{ __html: msg }}
                      ></li>
                    </ul>
                  );
                })}
              </div>
            )}
          </TabPanel>
        </TabContext>
      </div>
    </>
  );
};

export default ApplicantsCreateFlow;

/// for dynamic Table config Object
const configuration = {
  isSearchbar: true,
  isPaging: true,
  isDropdownActions: true,
  isCheckbox: true,
  isActions: true,
  recordperPage: 1,
  currentPage: 1,
  totalRecords: 0,
  isTotalCount: true,
  totalRecordsCount: 0,
  totalRecordsCountText: "Total Applicants",
  limitData: 9,
  isCheckAlignRight: true,
  isPaginationTop: true,
  isSearchServer: true,
  isPagingServer: true,
  isPageRange: true,
};

const pannelobj1 = {
  title: "Add New Applicant",
  description: "",
  bgImage: "",
};

const pannelobj2 = {
  title: "Add New Applicant",
  description: "",
  bgImage: "",
};

const bulkResponseObj = {
  title: "Bulk Upload",
  description: "",
  bgImage: ``,
};

const smsObj = {
  title: "Send SMS",
  description: "",
  bgImage: "", // `${process.env.PUBLIC_URL}/assests/img/emailbackground.svg`,
};

const addToProjectObj = {
  title: "Add to Project",
  description: "",
  bgImage: "",
};
